import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';

function EditButton({ onClick, sectionKey, ...delegated }) {
  const styles = {
    padding: 0,
    '& > span': { margin: 0 }
  };

  return (
    <Button
      clickstreamProps={{
        elementName: 'checkout_card_edit',
        elementValue: sectionKey
      }}
      color="info"
      data-testid={`${sectionKey}-edit-button`}
      size="sm"
      sx={styles}
      variant="text"
      onClick={onClick}
      {...delegated}
    >
      <FormattedMessage id="shopping.page.checkout.edit" />
    </Button>
  );
}

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  sectionKey: PropTypes.string.isRequired
};

export default EditButton;
